import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faInfoCircle, faLegal } from "@fortawesome/free-solid-svg-icons";

const OffboardedHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };

  const tabs = ["👥 Offboarded Search", "💳 Payment Dodger Search"];
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [customCity, setCustomCity] = useState("");
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [showLegalModal, setShowLegalModal] = useState(false);

  // Modal states
  const [showReportForm, setShowReportForm] = useState(false);
  const [reportType, setReportType] = useState(""); // "Offboarded" or "Payment Dodger"
  const [reportData, setReportData] = useState({ name: "", category: "", city: "" });
  const [formError, setFormError] = useState("");

  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showAbuseForm, setShowAbuseForm] = useState(false);
  const [abuseData, setAbuseData] = useState("");

  // Dummy data
  const offboardedList = [
    { id: 1, name: "Ramesh Kumar", category: "🚪 Departed", city: "Mumbai", details: "Left on good terms." },
    { id: 2, name: "Sita Sharma", category: "💼 Severance not paid", city: "Delhi", details: "Pending severance." },
    { id: 3, name: "Amit Singh", category: "🏃 Absconder", city: "Bangalore", details: "Did not return company assets." },
    { id: 4, name: "Priya Verma", category: "🔥 I Am Fired", city: "Pune", details: "Performance issues." },
    { id: 5, name: "Vikram Joshi", category: "⚖️ Offboarding Attorney", city: "Ahmedabad", details: "Legal matters." },
  ];

  const paymentDodgerList = [
    { id: 1, name: "Anil Mehta", category: "💸 Loan Evader", city: "Mumbai", details: "Has not returned MSME loan." },
    { id: 2, name: "Sunita Rao", category: "❌ Defaulter", city: "Delhi", details: "Payment overdue by 3 months." },
    { id: 3, name: "Rajesh Gupta", category: "📞 Non-payer", city: "Hyderabad", details: "Ignored reminders." },
    { id: 4, name: "Meena Iyer", category: "🗺️ Credit Escapee", city: "Chennai", details: "Moved city without payment." },
    { id: 5, name: "Karan Singh", category: "🕵️ Fugitive Debtor", city: "Bangalore", details: "Avoiding MSME repayment." },
  ];

  const handleSearch = (list) => {
    return list.filter(
      (p) =>
        p.name.toLowerCase().includes(searchKeyword.toLowerCase()) &&
        (searchCity ? p.city.toLowerCase().includes(searchCity.toLowerCase()) : true)
    );
  };

  const currentList = activeTab === tabs[0] ? offboardedList : paymentDodgerList;
  const filteredList = handleSearch(currentList);

  // Report buttons
  const openReportForm = (type) => {
    setReportType(type);
    setReportData({ name: "", category: "", city: "" });
    setFormError("");
    setShowReportForm(true);
  };

  const handleReportChange = (e) => {
    setReportData({ ...reportData, [e.target.name]: e.target.value });
  };

  const submitReport = () => {
    if (!reportData.name || !reportData.category || !reportData.city) {
      setFormError("All fields are required!");
      return;
    }
    alert(`Dummy confirmation: ${reportType} reported successfully!\nName: ${reportData.name}`);
    setShowReportForm(false);
  };

  // Abuse / Clarification form
  const submitAbuseForm = () => {
    if (!abuseData) {
      alert("Please enter your description!");
      return;
    }
    alert(`Dummy confirmation: Submitted successfully!\nDescription: ${abuseData}`);
    setAbuseData("");
    setShowAbuseForm(false);
  };

  return (
    <div className="min-h-screen bg-black text-white p-4">
      <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-red-800 px-4 py-3 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-red-400">🚀 Offboarded</div>
          <div className="text-xs lg:text-base text-yellow-200">
            Track, Report & Cleanup Absconders & Payment Dodgers!
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-sm text-red-300 text-left">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md bg-rose-600 hover:bg-rose-700 transition-colors"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 rounded-full border border-red-700 text-sm text-red-200 hover:bg-red-900 transition-colors"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-4 py-2 rounded-full bg-red-500 text-white text-sm hover:bg-red-400 transition-colors"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-xl text-red-300 bg-red-500 rounded-md hover:bg-red-600 transition-colors"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-red-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex items-center justify-center gap-3">
              <span className="text-red-300 font-medium text-sm">Welcome, {userName}</span>
              <button
                onClick={handleLogout}
                className="w-8 h-8 rounded-md bg-rose-600 hover:bg-rose-700 flex items-center justify-center text-white transition-colors"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex items-center justify-center gap-6">
              <Link to="/login" className="text-red-300 hover:text-yellow-300 text-sm transition-colors">
                Login
              </Link>
              <span className="text-red-500">|</span>
              <Link to="/signup" className="text-red-300 hover:text-yellow-300 text-sm transition-colors">
                Register
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="flex justify-center gap-3 bg-red-900/40 text-white text-sm py-3 mt-2 rounded-lg px-2 mb-2">
        <button
          className="bg-gray-600 hover:bg-gray-700 px-4 py-2 lg:w-1/4 rounded-md text-white text-sm lg:text-lg transition-colors flex items-center gap-2"
          onClick={() => setShowInfoModal(true)}
        >
          <FontAwesomeIcon icon={faInfoCircle} className="text-yellow-300" /> Issue & Benefits
        </button>
        <button
          className="bg-gray-600 hover:bg-gray-700 px-4 py-2 lg:w-1/4 rounded-md text-white text-sm lg:text-lg transition-colors flex items-center gap-2"
          onClick={() => setShowLegalModal(true)}
        >
          <FontAwesomeIcon icon={faLegal} className="text-yellow-300" /> Legal Disclaimer
        </button>
      </div>

      {/* Tabs */}
      <div className="flex flex-row justify-center gap-0 mb-1">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`py-3 px-4 rounded-md font-medium text-sm transition-colors flex-1 sm:flex-none sm:max-w-xs ${
              activeTab === tab ? "bg-yellow-600 text-white" : "bg-gray-800 text-gray-200 hover:bg-gray-700"
            }`}
            onClick={() => {
              setActiveTab(tab);
              setSelectedPerson(null);
              setSearchKeyword("");
              setSearchCity("");
              setCustomCity("");
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="flex flex-row gap-3 justify-center mb-1 place-items-center">
        <button
          className="bg-red-600 text-white hover:bg-red-700 py-3 px-4 rounded-md text-sm transition-colors flex-1 sm:flex-none sm:max-w-xs flex items-center justify-center gap-2"
          onClick={() => openReportForm("Offboarded")}
        >
          🚨 Report Offboarded
        </button>
        <button
          className="bg-orange-600 text-white hover:bg-orange-700 py-3 px-4 rounded-md text-sm transition-colors flex-1 sm:flex-none sm:max-w-xs flex items-center justify-center gap-2"
          onClick={() => openReportForm("Payment Dodger")}
        >
          ⚠️ Report Payment Dodger
        </button>
      </div>

      {/* Search */}
      <div className="bg-gray-600 p-2 rounded-md mb-3 w-full">
        <div className="flex items-center gap-2 w-full">
          <input
            type="text"
            placeholder="Enter name or ID 🔍"
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            className="flex-1 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400 text-black"
          />
          <input
            type="text"
            placeholder="City 📍"
            value={searchCity}
            onChange={(e) => setSearchCity(e.target.value)}
            className="flex-1 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400 text-black"
          />
          <button className="bg-blue-600 hover:bg-blue-700 text-white mt-4 w-8 px-2 py-2 rounded-md transition-colors flex items-center">
            <FontAwesomeIcon icon={faSearch} className="text-yellow-300 text-lg" />
          </button>
        </div>
      </div>


      {/* List */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mb-3">
        {filteredList.length === 0 ? (
          <p className="text-yellow-300 text-center col-span-full text-lg">❌ No records found.</p>
        ) : (
          filteredList.map((person) => (
            <div
              key={person.id}
              className="bg-gray-800 p-3 rounded-md cursor-pointer hover:bg-gray-700 transition-colors"
              onClick={() => setSelectedPerson(person)}
            >
              <p className="font-semibold text-base lg:text-lg">{person.name}</p>
              <p className="text-sm text-gray-300">{person.category}</p>
              <p className="text-sm text-gray-400">{person.city}</p>
            </div>
          ))
        )}
      </div>

      {/* Person Details */}
      {selectedPerson && (
        <div className="mt-3 bg-gray-900 p-4 rounded-md space-y-3">
          <h2 className="text-xl font-bold mb-3">📋 {selectedPerson.name} Details</h2>
          <p><strong>Category:</strong> {selectedPerson.category}</p>
          <p><strong>City:</strong> {selectedPerson.city}</p>
          <p><strong>Details:</strong> {selectedPerson.details}</p>
          <div className="flex gap-3 mt-3">
            <button
              className="bg-yellow-600 hover:bg-yellow-700 px-4 py-2 rounded-md text-sm transition-colors flex items-center gap-2"
              onClick={() => setShowAbuseForm(true)}
            >
              🚨 Report Abuse
            </button>
            <button
              className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded-md text-sm transition-colors flex items-center gap-2"
              onClick={() => setShowAbuseForm(true)}
            >
              💬 My Clarification
            </button>
            <button
              className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded-md text-sm transition-colors"
              onClick={() => setSelectedPerson(null)}
            >
              ❌ Close
            </button>
          </div>
        </div>
      )}

      {/* Report Form Modal */}
      {showReportForm && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50">
          <div className="bg-gray-800 p-6 rounded-md w-full max-w-md space-y-4 flex flex-col">
            <h2 className="text-xl font-bold flex w-full items-center gap-2">📝 Report {reportType}</h2>
            <input
              type="text"
              placeholder="Name 👤"
              name="name"
              value={reportData.name}
              onChange={handleReportChange}
              style={{width: "100%"}}              
              className="w-full px-3 py-2 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
            <input
              type="text"
              placeholder="Category 🏷️"
              name="category"
              value={reportData.category}
              onChange={handleReportChange}
              style={{width: "100%"}}              
              className="w-full px-3 py-2 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
            <input
              type="text"
              placeholder="City 📍"
              name="city"
              value={reportData.city}
              onChange={handleReportChange}
              style={{width: "80%"}}
              className="w-full px-3 py-2 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
            {formError && <p className="text-red-400 flex items-center gap-2">⚠️ {formError}</p>}
            <div className="flex justify-end gap-3 mt-3">
              <button
                className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded-md transition-colors"
                onClick={() => setShowReportForm(false)}
              >
                ❌ Cancel
              </button>
              <button
                className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md transition-colors flex items-center gap-2"
                onClick={submitReport}
              >
                🚀 Report Now
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Abuse / Clarification Form */}
      {showAbuseForm && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50">
          <div className="bg-gray-800 p-6 rounded-md w-full max-w-md space-y-4">
            <h2 className="text-xl font-bold flex items-center gap-2">💬 Submit Description</h2>
            <textarea
              placeholder="Enter description... 📝"
              value={abuseData}
              onChange={(e) => setAbuseData(e.target.value)}
              className="w-full h-24 px-3 py-2 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-yellow-400 resize-vertical"
            />
            <div className="flex justify-end gap-3 mt-3">
              <button
                className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded-md transition-colors"
                onClick={() => setShowAbuseForm(false)}
              >
                ❌ Close
              </button>
              <button
                className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded-md transition-colors flex items-center gap-2"
                onClick={submitAbuseForm}
              >
                ✅ Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MSME Info Modal */}
      {showInfoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50">
          <div className="bg-gray-800 p-6 rounded-md max-w-2xl space-y-4 overflow-y-auto max-h-[80vh]">
            <h2 className="text-xl font-bold mb-3 text-yellow-200 flex items-center gap-2">🌟 Social Significance & MSME Benefits</h2>

            <div className="space-y-4 text-sm text-gray-200">
              <h3 className="font-semibold text-lg text-yellow-300 flex items-center gap-2">1. 💪 Empowering MSMEs / Micro Enterprises</h3>
              <p><strong>Problem:</strong> Micro enterprises often struggle with employee misbehavior, absenteeism, or outright absconding, as well as clients/customers or partners who refuse to pay on time. This creates financial stress, operational disruption and legal hurdles.</p>
              <p><strong>Solution:</strong> This module provides a structured way to track these issues, report them and give visibility to stakeholders.</p>
              <p><strong>Impact:</strong> By logging Offboarded personnel and Payment Dodgers, MSME owners gain a centralized record, which is critical for preventive action, legal reference, or internal decision-making.</p>

              <h3 className="font-semibold text-lg text-yellow-300 flex items-center gap-2">2. ⚖️ Fairness and Accountability</h3>
              <p>The <strong>“Report Abuse”</strong> and <strong>“My Clarification”</strong> buttons ensure due process:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Accused employees/defaulters get a chance to clarify their side.</li>
                <li>MSMEs can report honest problems, but they are not making unilateral accusations.</li>
                <li>Later, if both parties resolve issues, the <strong>“All Is Well Now”</strong> update allows correction of records.</li>
              </ul>
              <p>This ensures the system is socially responsible and trustworthy, not punitive by default.</p>

              <h3 className="font-semibold text-lg text-yellow-300 flex items-center gap-2">3. 📜 Legal and Community Significance</h3>
              <p>The dashboard can act as a soft compliance and record-keeping tool.</p>
              <p>Over time, aggregated anonymous data can help:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Governments and industry bodies understand recurring problems.</li>
                <li>Banks and investors gauge reliability of micro-enterprises and partners.</li>
              </ul>
              <p>It promotes a culture of transparency, accountability and conflict resolution within MSME communities.</p>

              <h3 className="font-semibold text-lg text-yellow-300 flex items-center gap-2">4. 🧠 Psychological and Operational Relief</h3>
              <p>MSME owners often face stress and uncertainty when employees abscond or clients default.</p>
              <p>By having a structured reporting and resolution system, owners feel empowered, not isolated.</p>
              <p>Workers/employees know there’s a formal channel, which discourages misconduct.</p>

              <h3 className="font-semibold text-lg text-yellow-300 flex items-center gap-2">✅ Conclusion</h3>
              <p>This page is more than just a dashboard. It acts as:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>A social accountability platform for MSMEs.</li>
                <li>A conflict resolution and transparency tool for micro-enterprises.</li>
                <li>A data-driven mechanism to prevent recurring employee/partner issues.</li>
              </ul>
              <p>In short, it empowers MSMEs, protects their interests and encourages fair resolution, which is very socially significant in the Indian MSME ecosystem.</p>
            </div>

            <div className="flex justify-end mt-4">
              <button
                className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded-md transition-colors"
                onClick={() => setShowInfoModal(false)}
              >
                ❌ Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Legal Disclaimer Modal */}
      {showLegalModal && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50">
          <div className="bg-gray-800 p-6 rounded-md max-w-2xl space-y-4 overflow-y-auto max-h-[80vh]">
            <h2 className="text-xl font-bold mb-3 text-yellow-200 flex items-center gap-2">⚖️ Legal Disclaimer</h2>
            <div className="text-gray-200 text-sm space-y-3">
              <p>
                This platform is intended solely for internal MSME management purposes. All information listed here is reported by MSME owners or authorized users.
              </p>
              <p>
                The platform provides mechanisms for <strong>reporting Offboarded personnel or Payment Dodgers</strong> and allows the accused to submit clarifications via the <strong>“My Clarification”</strong> option.
              </p>
              <p>
                <strong>Important Legal Notes:</strong>
              </p>
              <ul className="list-disc list-inside space-y-1">
                <li>
                  Defamation: Under <strong>Section 499 & 500 of IPC</strong>, publishing unverified claims publicly can be considered defamation. This platform <strong>does not publish information publicly</strong>; access is restricted to registered MSMEs, auditors, banks, and authorized users.
                </li>
                <li>
                  Data Privacy: Complying with <strong>IT Act, 2000 (Sections 43A & 72A)</strong>, personal information must be protected. Do not share data outside the platform or misuse it.
                </li>
                <li>
                  Labor Laws: If reporting absconding employees, ensure adherence to <strong>Industrial Employment (Standing Orders) Act, 1946</strong> and other relevant labor regulations. Employees have rights to respond.
                </li>
                <li>
                  Financial Defaults: Reports of Payment Dodgers are for internal reference only and do not constitute legal judgment.
                </li>
              </ul>
              <p className="text-yellow-300">
                By using this platform, users agree to abide by Indian laws and the platform’s Terms of Use. Misuse may result in legal action.
              </p>
            </div>
            <div className="flex justify-end mt-4">
              <button
                className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded-md transition-colors"
                onClick={() => setShowLegalModal(false)}
              >
                ❌ Close
              </button>
            </div>
          </div>
        </div>
      )}

      <footer className="bg-[#2a0f2f] border-t border-red-800 text-red-500 py-4 mt-6">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved. 🌐
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-red-600 transition-colors">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-red-600 transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-red-600 transition-colors">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-red-600 transition-colors">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OffboardedHome;